import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'
import { setVh } from '../../styles/utils/conversion.style'
import { ContainerMain } from '../Container/index.style'
import { GridMain } from '../Grid/index.style'
import { mq } from '../../styles/vars/media-queries.style'
import { easings } from '../../styles/vars/easings.style'
import { Cta } from '../../styles/vars/textStyles.style'

export const VideoHeroWrapper = styled.div`
  background: ${colors.dark};
  ${setVh('height', 100)}
  overflow: hidden;

  &:before {
    background: ${colors.dark};
    bottom: 0;
    content: '';
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;

    [data-inview='true'] & {
      opacity: 0.35;
      transition: opacity 2.4s ${easings.out.quart} 2.8s;
    }
  }

  ${ContainerMain} {
    height: 100%;
  }
  ${GridMain} {
    height: 100%;
  }
  .react-parallax {
    position: relative;
    height: 100%;
    width: 100%;
  }
`

export const VideoHeroVimeo = styled.div`
  bottom: 0;
  left: 0;
  opacity: ${props => (props.visible ? 1 : 0)};
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
`

export const VideoHeroMain = styled.div`
  ${setVh('height', 100)};
  opacity: ${props => (props.visible ? 1 : 0)};
  position: relative;
  z-index: 3;
`

export const VideoHeroInner = styled.div`
  color: ${colors.light};
  text-align: center;
`

export const VideoHeroTitle = styled.div`
  margin: 0 auto;
  max-width: 24rem;

  ${mq.tabletP} {
    max-width: none;
  }
`
export const VideoHeroExploreLink = styled.div`
  bottom: 0;
  color: ${colors.light};
  left: 50%;
  position: absolute;
  transform: translateX(-50%);

  ${Cta} {
    cursor: pointer;
    background-color: transparent;
    border: none;
  }

  > span {
    display: block;

    &:first-child {
      padding-bottom: 2.4rem;
    }
  }

  svg {
    margin: 0 auto;
  }
`
